/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_PausedInputs */

const he_account_notifications_paused = /** @type {(inputs: Account_Notifications_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מושהה`)
};

const en_account_notifications_paused = /** @type {(inputs: Account_Notifications_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Account_Notifications_PausedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_paused = /** @type {((inputs?: Account_Notifications_PausedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_PausedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_paused(inputs)
	return en_account_notifications_paused(inputs)
});